import { useAuth0 } from "@auth0/auth0-react";
import Grid from "@material-ui/core/Grid";
import Button from "components/button/Button";
import AlertDialog from "components/Dialog";
import RightDrawer from "components/drawer";
import NewDialog from "components/NewDialog/Dialog";
import Spinner from "components/spinner";
import { useFormik } from "formik";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import { MergeAccountsDetails } from 'pages/Members/MemberDetails/MergeAccounts/MergeAccountsDetails';
import { CancelButton, ConfirmButton, ContentWrapper, Wrapper } from 'pages/Members/MemberDetails/Theme';
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import { BeatLoader } from 'react-spinners';
import MyCard from "../../components/MemberCard/MemberCard";
import AccountsDrawer from "./accountsDrawer";
import "./style.scss";

const GridComponent = ({
  loading,
  setDrawerData,
  data,
  page,
  size,
  setPage,
  cardColor,
  refresh,
  setRefresh,
  formik,
  ...rest
}) => {
  const location = useLocation();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [accountId, setAccountId] = useState("");
  const [account, setAccount] = useState({});
  const [handleDelete, setHandleDelete] = useState(false);
  const [search_item_id, setSearch_item_id] = useState(null);
  const { getAccessTokenSilently } = useAuth0();
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [isFinanceActive, setIsFinanceActive] = useState(true);
  const [message, setMessage] = useState('')
  const [value, setValue] = useState('')
  const [loadingMerge, setLoadingMerge] = useState(false)
  const [accountById, setAccountById] = useState({})
  const [confirmClose, setConfirmClose] = useState(false);

  const mergeFormik = useFormik({
    enableReinitialize: true,
    initialValues: { account: {} },
    validationSchema: "",
  });
  useEffect(() => {
    const handleDelete = async () => {
      const token = await getAccessTokenSilently();
      await AuthService.deleteAccount({ accountID: accountId }, token)
        .then((res) => {
          if (res) {
            setOpenAlert(false);
            setOpen(false);
            setRefresh(!refresh);
          }
        })
        .catch((err) => {
          setOpenAlert(false);
          toastr.error("Error", err?.data?.message);
        });
    };
    if (accountId) handleDelete();
  }, [handleDelete]);

  useEffect(() => {
    const Qparam = new URLSearchParams(location.search).get("q");
    if (!Qparam) return;
    setSearch_item_id(Qparam);
  }, [location.search]);

  useEffect(() => {
    if (!search_item_id) return;
    async function checkAccounAdmin() {
      const token = await getAccessTokenSilently();
      AuthService.getAccountById(search_item_id, token)
        .then((res) => {
          setAccountId(res?.[0]?._id);
          setAccount(res?.[0]);
          setOpen(true);
          const newLocation = { ...location, search: "" };
          history.replace(newLocation);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    checkAccounAdmin();
    // fetchMyAPI();
  }, [search_item_id]);
  const handleMergeButton = () => {
    setIsOpenMergePopUp(!isOpenMergePopUp)
    mergeFormik.setFieldValue('account', {});
    mergeFormik.setFieldValue('error', false);
    setValue('')
  }
  const handleMergeApi = async () => {
    const token = await getAccessTokenSilently();
    console.log("account", account, mergeFormik.values);
    const data = {
      accountId: mergeFormik.values.account?.accounts?._id,
      mergeToAccountId: accountById?._id
    }
    if (token) {
      setLoadingMerge(true)
      await FinanceService.MergeAccount(data, token)
        .then((res) => {
          handleMergeButton()
          toastr.success("Success", "Merged Account successfully");
        })
        .catch((err) => {
          toastr.error(
            "error",
            err?.data?.message || "Merged Account Failed"
          );
        }).finally(() => { setLoadingMerge(false) });
    }
  }


  const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    handleMergeButton()
  }


  return (
    <>
      {loading ? (
        <div className="member-loader">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="card-group">
            <Grid container spacing={3}>
              {data?.map((item, index) => {
                return (
                  <Grid item key={index} xs={12} lg={3} sm={4}>
                    <MyCard
                      setAccountId={setAccountId}
                      setOpenAlert={setOpenAlert}
                      cardColor={item.backGround}
                      onClick={(e) => {
                        setAccountId(item?._id);
                        setAccount(item);
                        setOpen(true);
                      }}
                      setAccountById={setAccountById}
                      onMergeClick={() => setIsOpenMergePopUp(!isOpenMergePopUp)}
                      page={page}
                      size={size}
                      member={item}
                      memberName={
                        item?.main_contact?.first_name &&
                          item?.main_contact?.last_name
                          ? `${item?.main_contact?.first_name} ${item?.main_contact?.middle_name
                            ? item?.main_contact?.middle_name
                            : ""
                          } ${item?.main_contact?.last_name}`
                          : "N/A"
                      }
                      paymentStatus={item?.payment?.paid ? "Paid" : "Pending"}
                      {...rest}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </div>
        </>
      )}
      <RightDrawer
        open={open}
        onClose={() => {
          setOpen(false);
          setSearch_item_id(null);
        }}
      >
        <AccountsDrawer
          accountId={accountId}
          account={account}
          setOpenAlert={setOpenAlert}
          refresh={refresh}
          setRefresh={setRefresh}
          onMergeClick={() => { setIsOpenMergePopUp(!isOpenMergePopUp); setOpen(false); }}
          setAccountById={setAccountById}
        />
      </RightDrawer>
      <AlertDialog
        open={openAlert}
        onDecline={() => setOpenAlert(false)}
        onAccept={() => setHandleDelete(!handleDelete)}
        title={`Are you sure?`}
        description={`Do you want to delete this account?`}
      />
      {Object.keys(accountById).length > 0 && 
      <NewDialog isOpen={isOpenMergePopUp} message={message} handleClose={closeModal}
        loading={loadingMerge}
        title={"Merge Accounts"}
        sx={{ '& .MuiDialog-paperWidthSm': { minWidth: "997.01px", height: "97%" } }}
        content={<ContentWrapper>
          <MergeAccountsDetails account={accountById} formik={mergeFormik} value={value} setValue={setValue} />
          <Wrapper>
            <Button
              onClick={closeModal}              
              variant="primary-outline"
              size="md"
              style={{ minWidth: "100px" }}
            >
              <span>Cancel</span>
            </Button>
            <Button
              onClick={handleMergeApi}             
              variant="primary"
              size="md"
              style={{ minWidth: "100px" }}
              disabled={loadingMerge || !value.toLowerCase().includes('merge')}
            >
               {loadingMerge ? (
                <BeatLoader color="#fff" size={6} margin={1} />
              ) : <span>Merge</span>}
            </Button>
          </Wrapper>
        </ContentWrapper>}
        contentStyle={{ display: 'flex', justifyContent: 'center', height: '100%' }}
        buttonStyle={{ justifyContent: 'right' }}
      >
      </NewDialog>

      }

      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
    </>
  );
};

export default GridComponent;
